import { Component, OnInit } from '@angular/core';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  progressRef: NgProgressRef;

  constructor(
    public ngProgress: NgProgress,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
  }

}
